import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';

import IconContainer from 'presentation/components/icons/IconContainer';
import { CLOSE_ICON_TYPE } from 'enums/configuration';

import styles from 'presentation/components/styles/CloseButton.css';

export default function CloseButton({ className, iconType, onClick, onKeyDown, title }) {
  let cx = classnames.bind(styles);
  let wrapperClasses = cx(styles.closeButton_wrapper, className);
  return (
    <div
      tabIndex="0"
      role="button"
      className={wrapperClasses}
      onKeyDown={onKeyDown}
      onClick={onClick}
      aria-label="closeButton"
    >
      <div tabIndex="-1" className={styles.closeButton} aria-label="closeButton" role="button">
        <IconContainer className={styles.closeChatIcon} viewBox="0 0 16 15" title={title} titleId="closeButtonTitleId">
          {iconType === CLOSE_ICON_TYPE.DASH_ICON ? <DashIcon /> : <XIcon />}
        </IconContainer>
      </div>
    </div>
  );
}

function DashIcon() {
  return <path d="M0 8h15" strokeLinecap="square" />;
}

export function XIcon() {
  return <path d="M15.5.5L1.77 14.23M1.315.693l13.73 13.73" fill="none" strokeLinecap="square" />;
}

CloseButton.propTypes = {
  className: PropTypes.string,
  iconType: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func,
  title: PropTypes.string.isRequired,
};
